<div class="menu-item">
  <ng-content />
</div>
